import React, { useState } from 'react';
// components
import SimpleText from '../components/SimpleText';
import SimpleImage from '../components/SimpleImage';
import Carousel from '../components/Carousel';
// ui
import Icon from '@material-ui/core/Icon';

const ResWrapper = ({
    obj,
    outputsEl,
    index,
    callbackFromParent,
    itemWrapperCallback
}) => {
    // state
    const [fixedRatio, setFixedRatio] = useState(false);

    // obj 콜백
    const parentCallback = dataFromChild => {
        // 기존값 넣어서 업데이트!
        let updatedData = obj.template.outputs;

        updatedData[dataFromChild.index] = dataFromChild;
        delete dataFromChild.index;

        //변경된 데이터 넣음
        let resultObj = {
            version: '2.0',
            template: {
                outputs: updatedData,
                quickReplies: obj.template.quickReplies
            }
        };
        //부모한테 전달
        callbackFromParent(resultObj);
    };

    // 순서 변경 및 제거
    const handleItemWrapper = e => {
        const action = e.target.name;
        itemWrapperCallback(index, action);
    };

    // 응답 넘버링
    let resNum = index;
    (() => {
        if (resNum === 0) resNum = '첫번째';
        if (resNum === 1) resNum = '두번째';
        if (resNum === 2) resNum = '세번째';
    })();

    // 응답 타입
    let resType = '';
    (() => {
        if (outputsEl.simpleText) resType = '텍스트';
        if (outputsEl.simpleImage) resType = '이미지';
        if (outputsEl.carousel) {
            if (outputsEl.carousel.type === 'basicCard') resType = '카드';
            if (outputsEl.carousel.type === 'textCard') resType = '텍스트 카드';
            if (outputsEl.carousel.type === 'imageCard')
                resType = '이미지 카드';
        }
    })();

    // 램덤 답변
    const randomCheck = e => {
        let data = outputsEl;
        data.carousel.random = !data.carousel.random;

        // 기존값 넣어서 업데이트!
        let updatedData = obj.template.outputs;

        updatedData[index] = data;

        //변경된 데이터 넣음
        let resultObj = {
            version: '2.0',
            template: {
                outputs: updatedData,
                quickReplies: obj.template.quickReplies
            }
        };
        //부모한테 전달
        callbackFromParent(resultObj);
    };

    // 카드 이미지 사이즈 조절
    const handleImgSize = e => {
        let data = outputsEl;
        if (e.target.name === 'square') {
            setFixedRatio(true);

            data.carousel.items.forEach(item => {
                item.thumbnail = { ...item.thumbnail, fixedRatio: true };
                if (item.buttons) {
                    const buttonsList = item.buttons.filter(
                        (btn, idx) => idx !== 2
                    );

                    buttonsList.forEach((button, idx) => {
                        item.buttons[idx].label = button.label.substr(0, 8);
                    });

                    item.buttons = buttonsList;
                }
            });
        } else {
            setFixedRatio(false);
            data.carousel.items.forEach(item => {
                delete item.thumbnail.fixedRatio;
            });
        }

        // 기존값 넣어서 업데이트!
        let updatedData = obj.template.outputs;

        updatedData[index] = data;

        //변경된 데이터 넣음
        let resultObj = {
            version: '2.0',
            template: {
                outputs: updatedData,
                quickReplies: obj.template.quickReplies
            }
        };

        //부모한테 전달
        callbackFromParent(resultObj);
    };

    // list
    let list;
    if (Object.keys(outputsEl)[0] === 'simpleText') {
        list = (
            <SimpleText
                key={index}
                outputsEl={outputsEl}
                index={index}
                callbackFromParent={parentCallback}
                itemWrapperCallback={itemWrapperCallback}
            />
        );
    } else if (Object.keys(outputsEl)[0] === 'simpleImage') {
        list = (
            <SimpleImage
                key={index}
                outputsEl={outputsEl}
                index={index}
                callbackFromParent={parentCallback}
                itemWrapperCallback={itemWrapperCallback}
            />
        );
    } else if (Object.keys(outputsEl)[0] === 'carousel') {
        list = (
            <Carousel
                key={index}
                outputsEl={outputsEl}
                index={index}
                callbackFromParent={parentCallback}
                itemWrapperCallback={itemWrapperCallback}
                fixedRatio={fixedRatio}
            />
        );
    } else {
        list = <div className="error-res">잘못된 응답 타입입니다.</div>;
    }

    return (
        <div className="contents-wrap">
            {/* 왼쪽 숫자 */}
            <div className="contents-number">
                <em>{index + 1}</em>
                {index !== 0 && (
                    <button
                        type="button"
                        onClick={handleItemWrapper}
                        className="prev"
                        name="up"
                    >
                        <Icon>keyboard_arrow_up</Icon>
                    </button>
                )}

                {obj.template.outputs.length !== 1 && (
                    <button
                        type="button"
                        onClick={handleItemWrapper}
                        className="next"
                        name="down"
                    >
                        <Icon>keyboard_arrow_down</Icon>
                    </button>
                )}

                {obj.template.outputs.length !== 1 && (
                    <button
                        type="button"
                        onClick={handleItemWrapper}
                        className="del"
                        name="del"
                    >
                        <Icon>delete_outline</Icon>
                    </button>
                )}
            </div>
            {/* 타이틀 */}
            <h2>
                {resNum} 응답 - {resType}
            </h2>
            {outputsEl.carousel && outputsEl.carousel.type === 'textCard' && (
                <div className="contents-random">
                    <label>
                        <input
                            type="checkbox"
                            onChange={randomCheck}
                            checked={outputsEl.carousel.random}
                        />
                        랜덤 답변 사용
                    </label>
                </div>
            )}

            {outputsEl.carousel && outputsEl.carousel.type === 'basicCard' && (
                <div className="contents-image-size">
                    <button
                        className={`${fixedRatio ? '' : 'active'}`}
                        onClick={handleImgSize}
                    >
                        2:1
                    </button>
                    <div className="fixed-ratio-txt">
                        이미지 비율을 2:1로 설정할 경우
                        <br />
                        버튼 배열이 세로형으로 변경되며 버튼의
                        <br />
                        최대 갯수는 3개로 변경됩니다.
                    </div>
                    <button
                        className={`${fixedRatio ? 'active' : ''}`}
                        onClick={handleImgSize}
                        name="square"
                    >
                        1:1
                    </button>
                    <div className="fixed-ratio-txt left">
                        이미지 비율을 1:1로 설정할 경우
                        <br />
                        버튼 배열이 가로형으로 변경되며 버튼의
                        <br />
                        최대 갯수는 2개, 글자수는 8자로 변경됩니다.
                    </div>
                </div>
            )}

            {/* 아이템 감싸는 영역 */}
            <div className="items-wrap">{list}</div>
        </div>
    );
};

export default ResWrapper;
